/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { useEffect } from 'react';
import { useConsumerTheme } from '../../hooks/useConsumerTheme';
import { createCSSGlobals } from './createCSSGlobals';

export namespace Bootstrap {
  export interface Props {}
}

export const Bootstrap: React.FC<Bootstrap.Props> = () => {
  const { appConfig } = useConsumerTheme();
  useEffect(() => createCSSGlobals(appConfig), [appConfig]);
  return null;
};
